import * as React from 'react';
import { createElement } from 'react';
import { Card, Table, Button, Loading, DatePicker2, Switch } from '@alifd/next';
import request from '@/utils/request';
import Operations from './operations';
import { workflowStore } from '@/store';
import { useLocalObservable, observer } from 'mobx-react';
import { openNewPage } from '@/utils';
const { Header, Content } = Card;
const WorkflowAttachment = observer((props) => {
    const { documentId, setDocumentId, docListNbr, documentPermissions } = useLocalObservable(() => workflowStore);
    const [docId, setDocId] = React.useState();
    const [files, setFiles] = React.useState([]);
    const [docTypes, setDocTypes] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [widths, setWidths] = React.useState({
        docTypeId: 150,
        docTypeNm: 150,
        'resDocPhyInfoDTO.genOprNm': 100,
        'resDocPhyInfoDTO.genTime': 180,
        'resDocPhyInfoDTO.fileNm': 100,
        lockdInd: 100,
    });
    const [editRow, setEditRow] = React.useState();
    const { __designMode, ctx: __ctx } = props;
    const isDesign = __designMode === 'design';
    const { type = 'create', } = __ctx?.appHelper?.constants || {};
    const queryFilesList = React.useCallback(async (bizDocListId) => {
        if (bizDocListId) {
            try {
                setLoading(true);
                const { content = [] } = await request.get(`/api/document/bizDocDetail/${bizDocListId}`);
                setDocId(bizDocListId);
                setFiles(content);
                setLoading(false);
            }
            catch (error) {
                setLoading(false);
            }
        }
    }, []);
    const initDocListId = React.useCallback(async () => {
        if (docListNbr && !documentId) {
            const { content: { bizDocListId }, } = await request.post(`/api/document/bizDocListAndDetail/byDocListNbr?docListNbr=${docListNbr}`);
            queryFilesList(bizDocListId);
            setDocumentId(bizDocListId);
        }
    }, [docListNbr, documentId, queryFilesList, setDocumentId]);
    const queryDocType = async () => {
        const { content = [] } = await request.get(`/api/document/docType/summary`);
        setDocTypes(content);
    };
    React.useEffect(() => {
        if (isDesign) {
            return;
        }
        queryFilesList(documentId);
    }, [documentId, isDesign, queryFilesList]);
    React.useEffect(() => {
        if (!isDesign) {
            queryDocType();
        }
    }, [isDesign]);
    const extra = () => {
        return (createElement(Button.Group, null,
            createElement(Button, { onClick: () => upload(docId) }, "\u65B0\u589E"),
            createElement(Button, { onClick: batchdownload, disabled: selectedRows.length === 0 }, "\u6279\u91CF\u4E0B\u8F7D"),
            createElement(Button, { onClick: () => queryFilesList(docId) }, "\u5237\u65B0")));
    };
    const upload = async (bizDocListId, num = 1) => {
        await request.post('/api/document/doc/bizDocDetail/repeat', { bizDocListId, num });
        queryFilesList(bizDocListId);
    };
    const batchdownload = () => {
        const ids = selectedRows.map((item) => item.bizDocListDtlId)?.join(',');
        const url = `/api/document/docDownLoad/batch?bizDocListDetailIds=${ids}`;
        openNewPage(url);
    };
    const onResizeChange = (dataIndex, value) => {
        const __widths = { ...widths };
        __widths[dataIndex] += value;
        setWidths(__widths);
    };
    return (createElement(Loading, { visible: loading },
        createElement(Card, { free: true, hasBorder: false },
            createElement(Header, { title: "\u6D41\u7A0B\u9644\u4EF6", extra: extra() }),
            createElement(Content, null,
                createElement("div", { style: { width: '100%' } },
                    createElement(Table.StickyLock, { fixedHeader: true, stickyHeader: true, isZebra: true, crossline: true, dataSource: files, primaryKey: "bizDocListDtlId", tableLayout: "fixed", onResizeChange: onResizeChange, rowSelection: {
                            mode: 'multiple',
                            onChange(selectedRowKeys, records) {
                                setSelectedRows(records);
                            },
                            getProps(record) {
                                return {
                                    disabled: !record?.resDocPhyInfoDTO?.fileNm,
                                };
                            },
                        } },
                        createElement(Table.Column, { title: "\u6587\u6863\u7C7B\u578B", align: "center", cell: (value) => {
                                const type = docTypes.find((item) => item.id === value)?.name;
                                return createElement("span", null, type);
                            }, dataIndex: "docTypeId", asyncResizable: true }),
                        createElement(Table.Column, { title: "\u6587\u4EF6\u540D\u79F0", align: "center", dataIndex: "docTypeNm", asyncResizable: true }),
                        createElement(Table.Column, { title: "\u6587\u4EF6\u4E0A\u4F20\u4EBA", align: "center", dataIndex: "resDocPhyInfoDTO.genOprNm", width: widths['resDocPhyInfoDTO.genOprNm'], asyncResizable: true }),
                        createElement(Table.Column, { title: "\u6587\u4EF6\u4E0A\u4F20\u65F6\u95F4", align: "center", dataIndex: "resDocPhyInfoDTO.genTime", asyncResizable: true, cell: (value) => {
                                return createElement(DatePicker2, { value: value, isPreview: true, format: 'YYYY-MM-DD HH:mm:ss' });
                            } }),
                        createElement(Table.Column, { title: "\u6587\u4EF6", align: "center", dataIndex: "resDocPhyInfoDTO.fileNm", asyncResizable: true }),
                        createElement(Table.Column, { title: "\u662F\u5426\u9501\u5B9A", align: "center", dataIndex: "lockdInd", asyncResizable: true, cell: (value) => {
                                return createElement(Switch, { checked: value, checkedChildren: "\u662F", unCheckedChildren: "\u5426" });
                            } }),
                        createElement(Table.Column, { title: "\u64CD\u4F5C", align: "center", width: 300, cell: (value, index, record) => {
                                const props = {
                                    record,
                                    queryFilesList,
                                    isDesign,
                                    docId,
                                    selectedRows,
                                    documentPermissions,
                                    setEditRow,
                                    editRow,
                                };
                                return createElement(Operations, { ...props });
                            } })))))));
});
WorkflowAttachment.displayName = 'WorkflowAttachment';
export default WorkflowAttachment;
